import {
  Product,
  SubIndustry
} from "@/pages/settings/components/settingsItems/hooks/types";
import { ISOStringFormat } from "date-fns";

export interface SettingsThresholds {
  id: string;
  low: number;
  medium: number;
  high: number;
  max?: number;
}

export interface SettingsThresholdsResponse {
  thresholds: SettingsThresholds[];
}

export interface AccountSetting {
  key: string;
  valueType: string;
  category: string;
  description: string | null;
  value: string | boolean | ISOStringFormat | null;
}

export interface SettingsState {
  thresholds: Record<string, SettingsThresholds>;
  setThresholds: (thresholds: SettingsThresholds[]) => void;
  accountSettings: Record<string, AccountSetting>;
  setAccountSettings: (settings: AccountSetting[]) => void;
  setAccountSetting: (setting: AccountSetting) => void;
}

export type CurrenciesResponse = string[];

export interface CurrencyRatesResponse {
  base: string;
  date: string; // Date of rates in YYYY-MM-DD format
  rates: {
    [currencyCode: string]: number;
  };
}

export interface CurrencyUsageResponse {
  systemCurrency: string | null;
  hasNonSystemCurrencyRecords: boolean;
}

export enum SettingsThresholdsType {
  CHAMPION_SCORE = "champion_score",
  CHAMPIONS_MAPPING_SCORE = "champions_mapping_score",
  KEY_STAKEHOLDERS_MAPPING_SCORE = "key_stakeholders_mapping_score",
  QUOTA_ACHIEVEMENT_LEVELS = "quota_achievement_levels"
}

export interface ProductsResponse {
  products: Product[];
}

export type SubIndustriesResponse = SubIndustry[];

// settingsapi industries (system-aware) — carries visibility/system flags,
// unlike the companies-service industry lookup (id/name only).
export interface SettingsIndustry {
  id: number;
  name: string;
  order?: number;
  isHidden?: boolean;
  isSystem?: boolean;
  createdAt?: string;
}

export interface SettingsIndustriesResponse {
  industries: SettingsIndustry[];
}
export interface ClosedLostReason {
  id: number;
  name: string;
  order: number;
  createdAt: string;
}

export interface ClosedLostReasonsResponse {
  closedLostReasons: ClosedLostReason[];
}

export interface LeadReason {
  id: number;
  name: string;
  order: number;
  createdAt: string;
}

export interface DisqualifiedReasonsResponse {
  disqualifiedReasons: LeadReason[];
}

export interface ClosedAsQualifiedReasonsResponse {
  closedAsQualifiedReasons: LeadReason[];
}

export interface TokenStatus {
  service: string;
  user: string;
  lastUpdatedAt: string;
}

export interface TokenError {
  message: string;
  statusCode?: number;
}

export interface Token {
  service: string;
  user: string;
  lastUpdatedAt: ISOStringFormat | null;
  isValid: boolean;
  // Why the connection needs a reconnect, when the server knows. Zoom sends
  // "missing_scopes", "role_lookup_denied" or "revoked".
  reason?: string | null;
}

export interface TokensData {
  allValid: boolean;
  tokens: Token[];
}

export interface WorkflowScoreStatusItem {
  id: number;
  name: string;
  reason: string | null;
  createdAt: string | null;
}

export interface WorkflowScoreStatusesResponse {
  scoreStatuses: WorkflowScoreStatusItem[];
}
